// Menu action header bar
export const buttonPermissions = {
  admin: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Gia hạn dịch vụ',
    'Chuyển xuống đại lý',
    'Thu hồi',
    'Xóa'
  ],
  agency: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Gia hạn dịch vụ',
    'Chuyển xuống đại lý',
    'Chọn người bán',
    'Thu hồi'
  ],
  staff: ['Kích hoạt', 'Chọn gói dịch vụ'],
  enduser: ['Kích hoạt'],
  accountant: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Gia hạn dịch vụ',
    'Chuyển xuống đại lý'
  ],
  sale: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Gia hạn dịch vụ',
    'Chuyển xuống đại lý',
    'Thu hồi'
  ],
  lead_marketing: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Gia hạn dịch vụ',
    'Chuyển xuống đại lý',
    'Thu hồi'
  ],
  customer_care: ['Kích hoạt'],
  technician: []
};

// Menu action right
export const menuPermissions = {
  admin: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'TRANSFER_AGENT',
    'EXTEND',
    'RECALL',
    'WARRANTY_REPLACEMENT',
    'SELECT_SELLER',
    'DELETE',
    'EXTEND_SERVICE',
    'GOTO_MAP',
    'RETURN_TO_STOCK',
    // 'CONTROL_ALERT',
    // 'ADD_DISPLAY_NAME',
    // 'SWAP_LICENSE_PLATE',
    // 'CHANGE_LICENSE_PLATE'
  ],
  agency: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'EXTEND',
    'RECALL',
    'SELECT_SELLER',
    // 'ADD_DISPLAY_NAME',
    // 'SWAP_LICENSE_PLATE',
    'TRANSFER_AGENT',
    'GOTO_MAP',
    // 'CONTROL_ALERT',
    // 'CHANGE_LICENSE_PLATE'
  ],
  staff: [
    'ACTIVATE',
    'EXTEND',
    'EDIT_DEVICE',
    // 'CHANGE_LICENSE_PLATE'
  ],
  enduser: [
    'ACTIVATE',
    'EDIT_DEVICE',
    // 'ADD_DISPLAY_NAME',
    // 'SWAP_LICENSE_PLATE',
    // 'CONTROL_ALERT',
    // 'CHANGE_LICENSE_PLATE'
  ],
  accountant: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'TRANSFER_AGENT',
    'EXTEND',
    'SELECT_SELLER',
    'DELETE',
    'EXTEND_SERVICE',
    // 'CONTROL_ALERT',
    // 'ADD_DISPLAY_NAME',
    // 'SWAP_LICENSE_PLATE',
  ],
  sale: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'TRANSFER_AGENT',
    'EXTEND',
    'RECALL',
    'SELECT_SELLER',
    // 'CONTROL_ALERT',
    // 'DELETE',
    // 'ADD_DISPLAY_NAME',
    // 'SWAP_LICENSE_PLATE',
  ],
  lead_marketing: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'TRANSFER_AGENT',
    'EXTEND',
    'RECALL',
    'SELECT_SELLER',
  ],
  customer_care: [
    'ACTIVATE',
    'EDIT_DEVICE',
    'GOTO_MAP',
    'WARRANTY_REPLACEMENT'
  ],
  technician: []
};
